import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {UnrAdsComponent} from './ads/ads.component';
import {UnrCommentListComponent} from './comment-list/comment-list.component';
import {UnrGoogleMapComponent} from './maps/components/google-map/google-map.component';
import {UnrHamburgerComponent} from './hamburger/hamburger.component';
import {UnrMainHeaderComponent} from './main-header/main-header.component';
import {UnrMapKitMapComponent} from './maps/components/mapkit-map/mapkit-map.component';

import {IosMapService} from './maps/services/ios-map.service';
import {MAP_SERVICE} from './maps/services/map.injection-token';
import {UnrModalComponent} from './modal/unr-modal.component';
import {NoBackgroundDirective} from './no-background/no-background.directive';
import {PLATFORM} from './platform.injection-token';
import {NgPipesModule} from 'ngx-pipes';
import {UnrSettingRecordingAccuracyModalComponent} from './modal/rating/setting-recording-accuracy-modal.component';
import {FormsModule} from '@angular/forms';
import {UnrImageViewer} from './image-viewer/image-viewer.component';

@NgModule({
  declarations: [
    UnrMainHeaderComponent,
    UnrHamburgerComponent,
    UnrGoogleMapComponent,
    UnrMapKitMapComponent,
    UnrCommentListComponent,
    NoBackgroundDirective,
    UnrAdsComponent,
    UnrModalComponent,
    UnrImageViewer,
    UnrSettingRecordingAccuracyModalComponent
  ],
  exports: [
    UnrMainHeaderComponent,
    UnrHamburgerComponent,
    UnrGoogleMapComponent,
    UnrMapKitMapComponent,
    UnrCommentListComponent,
    NoBackgroundDirective,
    UnrAdsComponent,
    UnrModalComponent,
    UnrImageViewer,
    UnrSettingRecordingAccuracyModalComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    NgPipesModule,
    FormsModule
  ],
  providers: [
    {
      provide: MAP_SERVICE, useFactory: (platform, router) => {
        return new IosMapService(router);
      }, deps: [PLATFORM, Router]
    }
  ]
})
export class SharedModule {
}
